<div style="position: relative">
  <div #wrapperFilterHeader style="display: inline-block; width: 100%">
    <lib-filter-header
      #ixFilterItemHeader
      [label]="this.label"
      [valueAll]="this.valueAll"
      [value]="this.getValue()"
      [isNumberFormat]="true"
      [divFocusClass]="this.filterItemHeaderDivFocusClass"
      [activeAngleDown]="!!op1?.overlayVisible"
      [angleDefaultAction]="true"
      [showDropdownButton]="true"
      [isFocusOn]="this.focusFilterItemHeader"
      (ixClick)="this.onFilterToggle($event)"
      (ixClickDown)="this.onClickDown($event)"
    />
  </div>
</div>

<p-popover
  #op1
  ixOverlay
  class="CssFilterOverlayPanel"
  [appendTo]="this.appendTo"
  (onHide)="this.onHide()"
>
  <ng-template #content>
    <div tabindex="0" (keydown)="onKeydown($event)">
      <!--Search mode-->
      <p-tabs
        class="CssIxTabView"
        [ngClass]="{
          CssIxTabViewHidden:
            (this.advancedFieldOd === undefined || this.advancedFieldDo === undefined) &&
            this.advancedFieldMnozicaElem === undefined &&
            this.advancedFieldObstaja === undefined &&
            !this.showCloseIcon &&
            !this.showHelpIcon,
        }"
        [value]="this.searchMode"
        (valueChange)="this.onSearchMode($event)"
      >
        <p-tablist>
          <p-tab [value]="'field'">{{
            this.language === Language.EN ? 'Value' : 'Vrednost'
          }}</p-tab>
          <p-tab [value]="'advancedFieldOdDo'">{{
            this.language === Language.EN ? 'From - To' : 'Od - Do'
          }}</p-tab>
          <div
            class="p-tab"
            style="display: flex; width: 15px; justify-content: center; margin-left: auto"
            (click)="op1.hide()"
            (keyup.enter)="op1.hide()"
            tabindex="0"
          >
            <i pButtonIcon class="pi pi-times"></i>
          </div>
        </p-tablist>

        <p-tabpanels style="padding: 5px">
          <p-tabpanel id="field" [value]="'field'">
            <ix-number
              #fieldComponent
              style="width: 100%; display: block; padding: 5px 0 5px 0"
              field="field"
              [ixFormGroup]="this.ixFormGroupUtil.ixFormGroup"
              [placeholder]="this.language === Language.EN ? 'Value' : 'Vrednost'"
              [readOnlyForce]="false"
              [format]="this.format"
              (ixChange)="this.onNumberChange($event, true)"
            />
          </p-tabpanel>
          <p-tabpanel id="advancedFieldOdDo" [value]="'advancedFieldOdDo'">
            <ix-number
              #advancedFieldOdComponent
              field="advancedFieldOd"
              style="width: 100%; display: block; padding: 5px 0 5px 0"
              [ixFormGroup]="this.ixFormGroupUtil.ixFormGroup"
              [placeholder]="this.language === Language.EN ? 'From' : 'Od'"
              [readOnlyForce]="false"
              [format]="this.format"
              (keyup)="this.onNumberChange($event, true)"
            />
            @if (this.advancedFieldDo) {
              <ix-number
                #advancedFieldDoComponent
                style="width: 100%; display: block; padding-bottom: 5px"
                field="advancedFieldDo"
                [ixFormGroup]="this.ixFormGroupUtil.ixFormGroup"
                [placeholder]="this.language === Language.EN ? 'To' : 'Do'"
                [readOnlyForce]="false"
                [format]="this.format"
                (keyup)="this.onNumberChange($event, true)"
              />
            }
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>
  </ng-template>
</p-popover>
